import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { PublicLayout, LoadingSpinner } from '@catalyze/ui';
import { apiClient } from 'api/apiClient';
import { CardContainer } from 'features/SignUp/components/CardContainer';
import { FormTitle } from 'features/SignUp/components/FormTitle';

const content = {
    '': {
        title: 'Loading...',
        subtitle: 'Please wait while we create your account.',
    },
    'no-session-id': {
        title: 'Unable to find subscription',
        subtitle:
            'Failed to create subscription, please try again or contact support.',
    },
    'create-user-fail': {
        title: 'Unable to create user',
        subtitle: 'Failed to create user, please try again or contact support.',
    },
    'create-user-success': {
        title: 'Catalyze Subscription Created!',
        subtitle: 'Please check your email to set up a password and log in.',
    },
};

export const SubscribedV2 = () => {
    const [isPageLoading, setIsPageLoading] = useState<boolean>(true);
    const [contentKey, setContentKey] = useState<keyof typeof content>();
    const [searchParams] = useSearchParams();

    const checkoutSessionId = searchParams.get('session_id');

    useEffect(() => {
        if (!checkoutSessionId) {
            setContentKey('no-session-id');
            setIsPageLoading(false);
            return;
        }

        // eslint-disable-next-line
        apiClient
            .post(`users/create-v2`, {
                json: { checkoutSessionId },
            })
            .then(() => {
                setContentKey('create-user-success');
                setIsPageLoading(false);
            })
            .catch(() => {
                setContentKey('create-user-fail');
                setIsPageLoading(false);
            });
    }, [checkoutSessionId]);

    const { title, subtitle } = useMemo(
        () => content[contentKey ?? ''],
        [contentKey]
    );

    return (
        <PublicLayout>
            <CardContainer style={{ marginBottom: 100 }}>
                {isPageLoading && <LoadingSpinner />}
                {!isPageLoading && (
                    <FormTitle title={title} subtitle={subtitle} />
                )}
            </CardContainer>
        </PublicLayout>
    );
};
